export default defineAppConfig({
  ui: {
    primary: 'primary-green',
    secondary: 'secondary',
    white: '#ffffff',
    black: '#000000',
    notifications: {
      position: 'top-14 bottom-auto',
    },
  },
});
